import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=f7a28d08&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=f7a28d08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a28d08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a28d08')) {
      api.createRecord('f7a28d08', component.options)
    } else {
      api.reload('f7a28d08', component.options)
    }
    module.hot.accept("./SvgIcon.vue?vue&type=template&id=f7a28d08&scoped=true", function () {
      api.rerender('f7a28d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/store-customization-v2/components/SvgIcon.vue"
export default component.exports